import { render, staticRenderFns } from "./RadiusAccounts.vue?vue&type=template&id=4d9e8652&scoped=true"
import script from "./RadiusAccounts.vue?vue&type=script&lang=js"
export * from "./RadiusAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9e8652",
  null
  
)

export default component.exports